import React, { useState } from 'react';
import aleximage from './aleximage.jpeg';
import cbbh from './cbbh.png'
import chessimage from './chess.png';
import videogame from './videogame.png';
import pingpong from './pingpong.png';
import clack from './clack.png';
import paintprogram from './paintprogram.png';
import shootergame from './shootergame.jpg';
import warehousegame from './warehousegame.png';
import speedgame from './speedgame.PNG';
import speedregister from './speedregister.PNG';
import speedsearching from './speedsearching.PNG';
import speedplaycard from './speedplaycard.png';
import jugpuzzle from './jugpuzzle.png';
import burpcert from './burpcert.png';
import pentesting from './pentesting.jpg';
import aisafety from './aisafety.jpg';
import redteaming from './redteaming.png';
import aiorchestration from './aiorchestration.png';
import softwareengineering from './softwareengineering.png';
import poetryimg from './poetry.png';
import './App.css';
import TopNav from './components/TopNav/TopNav.js';
import { Image, Container, Row, Col, Table, Carousel } from 'react-bootstrap';
import { BrowserRouter as Router } from 'react-router-dom';
import { MdArrowUpward, MdOpenInNew } from 'react-icons/md';
import { HashLink as Link } from 'react-router-hash-link';
import ExperienceTimeLine from './components/ExperienceTimeLine/ExperienceTimeLine';
import CWEEpath from './CWEEpath.png';
import CPTSpath from './CPTSpath.png';
import COAEcert from './COAEcert.png';
import cisspbadge from './cisspbadge.png';

function App() {
  const [expandedProjects, setExpandedProjects] = useState({});
  const [expandedCertifications, setExpandedCertifications] = useState({});

  const toggleProjectExpansion = (projectId) => {
    setExpandedProjects(prev => ({
      ...prev,
      [projectId]: !prev[projectId]
    }));
  };

  const toggleCertExpansion = (certId) => {
    setExpandedCertifications(prev => ({
      ...prev,
      [certId]: !prev[certId]
    }));
  };
  return (
    <Router>
      <div className="App">
        <header id="top" role="banner" className="page-header">
          <TopNav />
          
          <section id="header-body" className="hero-section" aria-labelledby="intro-heading">
            <Image 
              src={aleximage} 
              id="aleximage" 
              alt="Alexander Yeara, Application and Security Engineer" 
              roundedCircle 
            />
            <h1 id="intro-heading" className="hero-title">
              Hi! I'm Alexander Yeara
            </h1>
            <p className="hero-subtitle hero-name-alias">
              (AKA ApogeeBytes)
            </p>
            <p className="hero-subtitle">
              I'm a software and product security engineer based in Toronto, Canada.
            </p>
          </section>
        </header>

        <main id="main-content" className="main-content" role="main" tabIndex="-1">
          <div className="section-wrapper section-bg-1">
            <Container id="about" className="content-section">
            <h2>About Me</h2>
            <div className="about-content">
              <p>
                I'm an Application Security Engineer at <strong>Okta</strong> and former Software Engineer at <strong>Microsoft</strong>. I focus on penetration testing, code reviews, threat modeling, and vulnerability management to help strengthen Okta's security posture.
              </p>
              <p>
                At Microsoft, I built features for the Whiteboard Integrations team and served as a Security Champion.
              </p>
              <p>
                I hold an Honours BSc in Computer Science, Chemistry, and Mathematics from the University of Toronto, where I also conducted cancer research, presided over the campus chess club, and supported teaching three CS courses.
              </p>
              <p>
                In my free time, I'm an avid online bullet chess player (≈2300 on Lichess and Chess.com) and enjoy tinkering with AI while expanding my security expertise.
              </p>
            </div>

            <section className="hobby-section" aria-labelledby="hobbies-heading">
              <h3 id="hobbies-heading">Interests & Hobbies</h3>
              <div className="hobby-icon-container flex" role="list">
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={softwareengineering} 
                    className="hobby-images" 
                    alt="Software engineering and coding development"
                  />
                  <figcaption>Software Engineering</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={pentesting} 
                    className="hobby-images" 
                    alt="Computer security and penetration testing interface"
                  />
                  <figcaption>Penetration Testing</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={redteaming} 
                    className="hobby-images" 
                    alt="Team collaboration and red teaming strategy"
                  />
                  <figcaption>Red Teaming</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={aisafety} 
                    className="hobby-images" 
                    alt="Artificial intelligence and AI safety"
                  />
                  <figcaption>AI Safety</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={aiorchestration} 
                    className="hobby-images" 
                    alt="AI orchestration and automation"
                  />
                  <figcaption>AI Orchestration</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={chessimage} 
                    className="hobby-images" 
                    alt="Chess pieces on a board"
                  />
                  <figcaption>Chess</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={videogame} 
                    className="hobby-images" 
                    alt="Video game controller"
                  />
                  <figcaption>Video Games</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={pingpong} 
                    className="hobby-images" 
                    alt="Ping pong paddles and ball"
                  />
                  <figcaption>Ping Pong</figcaption>
                </figure>
                <figure className="hobby-item" role="listitem">
                  <Image 
                    src={poetryimg} 
                    className="hobby-images" 
                    alt="Poetry writing and creative literature"
                  />
                  <figcaption>Poetry</figcaption>
                </figure>
              </div>
            </section>
          </Container>
          </div>

          <div className="section-wrapper section-bg-2">
            <Container id="experience" className="content-section">
            <h2 id="experience-heading">Professional Experience</h2>
            <ExperienceTimeLine />
          </Container>
          </div>

          <div className="section-wrapper section-bg-1">
            <Container id="portfolio" className="content-section">
            <h2>Projects</h2>

            <article className={`project-item ${expandedProjects['speed'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="project-toggle-btn"
                onClick={() => toggleProjectExpansion('speed')}
                aria-expanded={expandedProjects['speed'] || false}
                aria-controls="project-details-speed"
              >
                <h3>React Speed (Pre-AI)</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="project-details-speed" className="project-details-container">
              <Row className="project">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="project-desc">
                    <p className="project-summary">An online multiplayer card game with authentication, matchmaking, and real-time gameplay.</p>
                    <ul>
                      <li>
                        Sole developer of an online multiplayer card game with authentication, matchmaking, and real-time gameplay.
                      </li>
                      <li>
                        Features include game settings, quickplay, player lobby, user profile, leaderboard, registration, and password change/reset.
                      </li>
                      <li>
                        <strong>Technologies: </strong>React, MongoDB, Node.js, Express, and Socket.IO
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Carousel 
                    aria-label="React Speed game screenshots carousel"
                    role="region"
                    aria-live="polite"
                    aria-atomic="false"
                  >
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={speedplaycard}
                        alt="Speed card game card movement mechanics - Slide 1 of 4"
                      />
                      <Carousel.Caption className="sr-only">
                        Card movement mechanics demonstration in React Speed game
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={speedgame}
                        alt="Speed card game main gameplay screen - Slide 2 of 4"
                      />
                      <Carousel.Caption className="sr-only">
                        Main gameplay interface showing real-time multiplayer card game
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={speedsearching}
                        alt="Speed card game player search interface - Slide 3 of 4"
                      />
                      <Carousel.Caption className="sr-only">
                        Player search and matchmaking interface
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={speedregister}
                        alt="Speed card game user registration form - Slide 4 of 4"
                      />
                      <Carousel.Caption className="sr-only">
                        User registration form with authentication
                      </Carousel.Caption>
                    </Carousel.Item>
                  </Carousel>
                </Col>
              </Row>
              </div>
            </article>

            <article className={`project-item ${expandedProjects['clack'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="project-toggle-btn"
                onClick={() => toggleProjectExpansion('clack')}
                aria-expanded={expandedProjects['clack'] || false}
                aria-controls="project-details-clack"
              >
                <h3>CS50 Clack (Pre-AI)</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="project-details-clack" className="project-details-container">
              <Row className="project">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="project-desc">
                    <p className="project-summary">A lightweight single-page messaging website built as part of Harvard's CS50 course.</p>
                    <ul>
                      <li>
                        Designed and developed a lightweight single-page messaging website as a practice assignment for Harvard's CS50 course.
                      </li>
                      <li>
                        Implemented client-side non-persistent storage for usernames and server-side non-persistent storage for channels and messages.
                      </li>
                      <li>
                        <strong>Technologies: </strong>Python, JavaScript, HTML, CSS, AJAX, Socket.io, Flask, History API, LocalStorage API
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 1}}>
                  <Image src={clack} className="portfolio-image" alt="CS50 Clack messaging interface" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`project-item ${expandedProjects['editor'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="project-toggle-btn"
                onClick={() => toggleProjectExpansion('editor')}
                aria-expanded={expandedProjects['editor'] || false}
                aria-controls="project-details-editor"
              >
                <h3>Graphics Editor (Pre-AI)</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="project-details-editor" className="project-details-container">
              <Row className="project">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="project-desc">
                    <p className="project-summary">A desktop graphics editor built with design patterns and team collaboration.</p>
                    <ul>
                      <li>
                        Designed and developed a desktop graphics editor as Scrum master and developer with a student team.
                      </li>
                      <li>
                        Incorporated the Observer, Factory, Command, and Strategy design patterns for the creation and manipulation of different shapes
                      </li>
                      <li>
                        <strong>Technologies: </strong>Java, Swing, Model-View-Controller (MVC), Agile/Waterfall methodologies, Version-Control Software (i.e. Git), design patterns and object-oriented programming
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={paintprogram} className="portfolio-image" alt="Graphics editor application interface" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`project-item ${expandedProjects['shooter'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="project-toggle-btn"
                onClick={() => toggleProjectExpansion('shooter')}
                aria-expanded={expandedProjects['shooter'] || false}
                aria-controls="project-details-shooter"
              >
                <h3>Shooter Game (Pre-AI)</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="project-details-shooter" className="project-details-container">
              <Row className="project">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="project-desc">
                    <p className="project-summary">A multiplayer browser game featuring physics and state management.</p>
                    <ul>
                      <li>
                        Contributed to the development of a multiplayer browser game by designing architecture, implementing gameplay physics, and improving the user interface.
                      </li>
                      <li>
                        Used object-oriented programming and a state design pattern to manage game flow transitions.
                      </li>
                      <li>
                        <strong>Technologies: </strong>JavaScript, HTML, CSS, Golang, SQL
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={shootergame} className="portfolio-image" alt="Shooter game gameplay screen" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`project-item ${expandedProjects['warehouse'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="project-toggle-btn"
                onClick={() => toggleProjectExpansion('warehouse')}
                aria-expanded={expandedProjects['warehouse'] || false}
                aria-controls="project-details-warehouse"
              >
                <h3>Warehouse Game (Pre-AI)</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="project-details-warehouse" className="project-details-container">
              <Row className="project">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="project-desc">
                    <p className="project-summary">A single-player puzzle game implemented with object-oriented design.</p>
                    <ul>
                      <li>
                        Developed a single-player game in Python as an early school assignment. The game's objective is to eliminate all monsters by surrounding them with boxes.
                      </li>
                      <li>
                        Used object-oriented programming for players, monsters, and boxes
                      </li>
                      <li>
                        <strong>Technologies: </strong>Python
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={warehousegame} className="portfolio-image" alt="Warehouse game puzzle level" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`project-item ${expandedProjects['jug'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="project-toggle-btn"
                onClick={() => toggleProjectExpansion('jug')}
                aria-expanded={expandedProjects['jug'] || false}
                aria-controls="project-details-jug"
              >
                <h3>Jug Puzzle Game (Pre-AI)</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="project-details-jug" className="project-details-container">
              <Row className="project">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="project-desc">
                    <p className="project-summary">A single-player puzzle game implemented using MVC architecture.</p>
                    <ul>
                      <li>
                        Developed a single-player jug puzzle game using object-oriented programming and Model-View-Controller (MVC) as a second-year student
                      </li>
                      <li>
                        <strong>Technologies: </strong>Java, Swing
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={jugpuzzle} className="portfolio-image" alt="Jug puzzle game interface" />
                </Col>
              </Row>
              </div>
            </article>


          </Container>
          </div>

          <div className="section-wrapper section-bg-2">
            <Container id="certifications" className="content-section">
            <h2>Certifications</h2>

            <article className={`certification-item ${expandedCertifications['cissp'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="certification-toggle-btn"
                onClick={() => toggleCertExpansion('cissp')}
                aria-expanded={expandedCertifications['cissp'] || false}
                aria-controls="cert-details-cissp"
              >
                <h3>Certified Information Systems Security Professional (CISSP)</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="cert-details-cissp" className="cert-details-container">
              <Row className="certification">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="certification-desc">
                    <p className="cert-issuer">(ISC)²</p>
                    <p>
                      <a href="https://www.credly.com/earner/earned/badge/d693931d-8235-49a8-9d9f-e06cefc5a2cd" target="_blank" rel="noopener noreferrer">
                        View Digital Credential
                      </a>
                    </p>
                    <p className="cert-description">
                      The CISSP certification validates advanced technical and managerial security expertise across a broad range of domains, including security and risk management, asset security, security engineering, communications and network security, identity and access management, security assessment and testing, security operations, and software development security.
                    </p>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={cisspbadge} className="certification-image" alt="Certified Information Systems Security Professional (CISSP) badge" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`certification-item ${expandedCertifications['coae'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="certification-toggle-btn"
                onClick={() => toggleCertExpansion('coae')}
                aria-expanded={expandedCertifications['coae'] || false}
                aria-controls="cert-details-coae"
              >
                <h3>Certified Offensive AI Expert</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="cert-details-coae" className="cert-details-container">
              <Row className="certification">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="certification-desc">
                    <p className="cert-issuer">Hack The Box</p>
                    <p>
                      <a href="https://profile.hackthebox.com/profile/019d5047-b479-7078-b346-497835e0ff0f/certificate/HTBCERT-953F9B6A34" target="_blank" rel="noopener noreferrer">
                        View Digital Credential
                      </a>
                    </p>
                    <p className="cert-description">
                      A hands-on certification assessing competency in identifying and exploiting vulnerabilities in AI and ML systems. Demonstrates expertise in adversarial machine learning, LLM prompt injection and jailbreaking, LLM output exploitation, AI application and system security, AI defense, and AI privacy. Developed in collaboration with Google and aligned with OWASP ML Security Top 10, Agentic Top 10, and LLM Applications 2025. Certification holders can conduct professional AI red-team assessments and write client-ready security reports.
                    </p>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={COAEcert} className="certification-image" alt="Certified Offensive AI Expert badge from Hack The Box" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`certification-item ${expandedCertifications['cbbh'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="certification-toggle-btn"
                onClick={() => toggleCertExpansion('cbbh')}
                aria-expanded={expandedCertifications['cbbh'] || false}
                aria-controls="cert-details-cbbh"
              >
                <h3>Certified Bug Bounty Hunter</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="cert-details-cbbh" className="cert-details-container">
              <Row className="certification">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="certification-desc">
                    <p className="cert-issuer">Hack The Box</p>
                    <p>
                      <a href="https://www.credly.com/badges/fa712a96-cff9-42e4-a0ae-ce14047ec946/public_url" target="_blank" rel="noopener noreferrer">
                        View Digital Credential
                      </a>
                    </p>
                    <blockquote className="cert-description">
                      <p>
                        HTB CBBH holders possess technical competency in the bug bounty hunting and web penetration testing domains at an intermediate level. They will be able to spot security issues and identify avenues of exploitation that may not be immediately apparent from searching for CVEs or known exploit PoCs. They can also think outside the box, chain multiple vulnerabilities to showcase maximum impact, and actionably help developers remediate vulnerabilities through commercial-grade bug reports.
                      </p>
                    </blockquote>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={cbbh} className="certification-image" alt="Certified Bug Bounty Hunter badge from Hack The Box" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`certification-item ${expandedCertifications['burp'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="certification-toggle-btn"
                onClick={() => toggleCertExpansion('burp')}
                aria-expanded={expandedCertifications['burp'] || false}
                aria-controls="cert-details-burp"
              >
                <h3>Burp Suite Certified Practitioner</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="cert-details-burp" className="cert-details-container">
              <Row className="certification">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="certification-desc">
                    <p className="cert-issuer">PortSwigger</p>
                    <p>
                      <a href="https://portswigger.net/web-security/e/c/ba029f4212ca75ac" target="_blank" rel="noopener noreferrer">
                        View Digital Credential
                      </a>
                    </p>
                    <blockquote className="cert-description">
                      <p>This certification, created by PortSwigger's Web Security Academy, demonstrates that I have the ability to:</p>
                      <ul>
                        <li>
                          Detect and prove the full business impact of a wide range of common web vulnerabilities.
                        </li>
                        <li>
                          Adapt attack methods to bypass broken defences, using knowledge of fundamental web technologies.
                        </li>
                        <li>
                          Quickly identify weak points within an attack surface and perform out-of-band attacks to target them.
                        </li>
                      </ul>
                    </blockquote>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={burpcert} className="certification-image" alt="Burp Suite Certified Practitioner badge from PortSwigger" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`certification-item ${expandedCertifications['cwee'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="certification-toggle-btn"
                onClick={() => toggleCertExpansion('cwee')}
                aria-expanded={expandedCertifications['cwee'] || false}
                aria-controls="cert-details-cwee"
              >
                <h3>Senior Web Penetration Tester Path</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="cert-details-cwee" className="cert-details-container">
              <Row className="certification">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="certification-desc">
                    <p className="cert-issuer">Hack The Box Academy</p>
                    <p>
                      <a href="https://academy.hackthebox.com/achievement/badge/839d8109-fced-11ee-b18d-bea50ffe6cb4" target="_blank" rel="noopener noreferrer">
                        View Digital Credential
                      </a>
                    </p>
                    <p className="cert-description">
                      The Senior Web Penetration Tester Job Role Path is designed for individuals who aim to develop skills in identifying advanced and hard-to-find web vulnerabilities using both black box and white box techniques.
                    </p>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={CWEEpath} className="certification-image" alt="Senior Web Penetration Tester path badge" />
                </Col>
              </Row>
              </div>
            </article>

            <article className={`certification-item ${expandedCertifications['cpts'] ? 'expanded' : 'collapsed'}`}>
              <button
                className="certification-toggle-btn"
                onClick={() => toggleCertExpansion('cpts')}
                aria-expanded={expandedCertifications['cpts'] || false}
                aria-controls="cert-details-cpts"
              >
                <h3>Certified Penetration Tester Path</h3>
                <span className="toggle-icon"><span className="toggle-chevron">▼</span></span>
              </button>
              <div id="cert-details-cpts" className="cert-details-container">
              <Row className="certification">
                <Col xs={{span: 12, order: 1}} md={{span:6, order: 1}}>
                  <div className="certification-desc">
                    <p className="cert-issuer">Hack The Box Academy</p>
                    <p>
                      <a href="https://academy.hackthebox.com/achievement/badge/88ae9c89-6377-11f0-bcfd-bea50ffe6cb4" target="_blank" rel="noopener noreferrer">
                        View Digital Credential
                      </a>
                    </p>
                    <p className="cert-description">
                      The Penetration Tester Job Role Path is for newcomers to information security who aspire to become professional penetration testers. This path covers core security assessment concepts and provides a deep understanding of the specialized tools, attack tactics, and methodology used during penetration testing.
                    </p>
                  </div>
                </Col>
                <Col xs={{span: 12, order: 2}} md={{span:6, order: 2}}>
                  <Image src={CPTSpath} className="certification-image" alt="Certified Penetration Tester path badge" />
                </Col>
              </Row>
              </div>
            </article>

          </Container>
          </div>

          <div className="section-wrapper section-bg-1">
            <Container id="othercerts" className="content-section">
            <h2>Additional Certifications</h2>
            <ul className="additional-certs-list">
              <li>
                Okta Certified Professional <a href="https://www.credly.com/badges/9adb524b-0949-4870-8598-b3bdd1e3c4dd" target="_blank" rel="noopener noreferrer">(View Digital Credential)</a>
              </li>
              <li>
                Auth0 Certified Developer <a href="https://www.credly.com/badges/f7b2ed31-ea94-4a10-bfb0-25be1a4211d4/public_url" target="_blank" rel="noopener noreferrer">(View Digital Credential)</a>
              </li>
              <li>OSCP (in progress)</li>
              <li>CWEE (in progress, path completed)</li>
            </ul>
          </Container>
          </div>

          <div className="section-wrapper section-bg-1">
            <Container id="disclosures" className="content-section">
              <h2>Blog & Disclosures</h2>
              <ul className="blog-list">
                <li>Websockets FTW in Popular Online Board Game (In Progress, Responsible Disclosure)</li>
                <li>Mass Vulnerable Onboarding of Condo Owners (In Progress, Responsible Disclosure)</li>
                <li><a href="https://github.com/auth0/symfony/security/advisories/GHSA-ffq7-hh2j-r24p" target="_blank" rel="noopener noreferrer">CVE-2026-50157 <MdOpenInNew style={{display: 'inline', marginLeft: '0.5em', verticalAlign: 'middle'}} aria-hidden="true" /></a></li>
                <li><a href="https://wpscan.com/vulnerability/da5936d2-a96f-4ff8-8562-1248734f577f/" target="_blank" rel="noopener noreferrer">CVE-2026-14845 <MdOpenInNew style={{display: 'inline', marginLeft: '0.5em', verticalAlign: 'middle'}} aria-hidden="true" /></a></li>
                <li><a href="https://wpscan.com/vulnerability/ea752266-9bff-4c36-91aa-9aca0232c7af/" target="_blank" rel="noopener noreferrer">CVE-2026-14860 <MdOpenInNew style={{display: 'inline', marginLeft: '0.5em', verticalAlign: 'middle'}} aria-hidden="true" /></a></li>
                <li><a href="https://github.com/auth0/ad-ldap-connector/security/advisories/GHSA-w2c4-h8qx-6m27" target="_blank" rel="noopener noreferrer">CVE-2026-85982 <MdOpenInNew style={{display: 'inline', marginLeft: '0.5em', verticalAlign: 'middle'}} aria-hidden="true" /></a></li>
                <li><a href="https://github.com/auth0/ad-ldap-connector/security/advisories/GHSA-8j7j-jhmw-p7jx" target="_blank" rel="noopener noreferrer">CVE-2026-85983 <MdOpenInNew style={{display: 'inline', marginLeft: '0.5em', verticalAlign: 'middle'}} aria-hidden="true" /></a></li>
              </ul>
            </Container>
          </div>

          <div className="section-wrapper section-bg-2">
            <Container id="contact" className="content-section contact-section">
            <h2>Contact Information</h2>
            <div className="contact-content">
              <p>
                <strong>Email:</strong> <a href="mailto:alexanderyeara2@gmail.com">alexanderyeara2@gmail.com</a>
              </p>
              <p>Feel free to send me a LinkedIn connection request or reach out directly!</p>
            </div>
          </Container>
          </div>
        </main>

        <footer className="page-footer" role="contentinfo">
          <Link smooth to="#top" className="back-to-top-link" aria-label="Back to top">
            <MdArrowUpward aria-hidden="true" /> 
            <span>Back to top</span>
          </Link>
        </footer>
      </div>
    </Router>
  );
}

export default App;
